import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { initializeWithConsent } from '@fff-web/consent';

const ENV = process.env.REACT_APP_ENVIRONMENT || 'dev';
const clientToken = 'pubab5701f32fad294512d4be599031f748';

const initializeDatadog = () => {
  datadogRum.init({
    applicationId: '5dfddc69-e7ef-43c6-a256-a10a89f06471',
    clientToken,
    site: 'datadoghq.com',
    service: 'my-account',
    env: ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
  });
  datadogRum.startSessionReplayRecording();
  datadogLogs.init({
    clientToken,
    env: ENV,
    service: 'my-account',
  });
};

export const bootstrapDatadog = () => initializeWithConsent('C0002', initializeDatadog);
